module.exports = __webpack_public_path__ + "3b494a4e048e08d44031053a7881e59b.fbx";